import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a63c2124&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a63c2124')) {
      api.createRecord('a63c2124', component.options)
    } else {
      api.reload('a63c2124', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a63c2124&", function () {
      api.rerender('a63c2124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/index.vue"
export default component.exports